/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function getAnchor() {
    return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
}

function chkTreuep() {
  if(getAnchor() == 'gameball-redemption'){
    return location.reload();
  } else {
    var lastChar = location.href.substr(-1); // Selects the last character
    if (lastChar != '/') {         // If the last character is not a slash
      location.href = 'https://ziitwundershop.com/cart/#gameball-redemption';
    } else {
      location.href = 'https://ziitwundershop.com/cart#gameball-redemption';
    }
  }
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var show_nl_popup = getParameterByName('nlpopup');
if(show_nl_popup != null && show_nl_popup != undefined) {
    setTimeout(() => {
      document.querySelector(".rm-open-popup").click();
    }, "3600");
}

//document.querySelector('.Header__Icon[data-drawer-id="sidebar-cart"]').addEventListener('click', function(event){
//    document.getElementById("trustbadge-container-98e3dadd90eb493088abdc5597a70810").style.zIndex = "1";
//});
const myTSInterval = setInterval(myTS, 1000);
function myTS() {
  if(document.getElementById("trustbadge-container-98e3dadd90eb493088abdc5597a70810") != null) {
    document.getElementById("trustbadge-container-98e3dadd90eb493088abdc5597a70810").style.zIndex = "4";
    clearInterval(myTSInterval);
  }
}

//const myaccessiblyAppWidgetInterval = setInterval(myaccessiblyAppWidget, 3000);
//function myaccessiblyAppWidget() {
//  if(document.getElementById("accessiblyAppWidgetButton") != null) {
//    document.getElementById("accessiblyAppWidgetButton").style.zIndex = "3";
//    clearInterval(myaccessiblyAppWidgetInterval);
//  }
//}

document.addEventListener('DOMContentLoaded', function(event) {
  if(window.matchMedia('screen and (max-width: 1007px)').matches) {
  	let ShopTheLookDots = document.querySelectorAll('.ShopTheLook__Dot');
  	ShopTheLookDots.forEach(Dot => {
  		Dot.addEventListener('click', function(){
  			document.querySelector("#accessiblyAppWidgetButton").style.visibility  = "hidden";
  		});
  	});
    
  	let ShopTheLookBtns = document.querySelectorAll('.ShopTheLook__DiscoverButtonWrapper');
  	ShopTheLookBtns.forEach(Btn => {
  		Btn.addEventListener('click', function(){
  			document.querySelector("#accessiblyAppWidgetButton").style.visibility  = "hidden";
  		});
  	});
  	
  	let Popovers = document.querySelectorAll('.Popover__Close');
  	Popovers.forEach(Pop => {
  		Pop.addEventListener('click', function(){
  			document.querySelector("#accessiblyAppWidgetButton").style.visibility  = "visible";
  		});
  	});
  }
});

var ref_mscklid = getParameterByName('msclkid');
if(ref_mscklid != null && ref_mscklid != undefined) {
  var lS_mscklid = localStorage.getItem("msclkid");
  if(lS_mscklid != '' && lS_mscklid != null && lS_mscklid != undefined) {
    fetch('https://apps.zeitwundershop.de/save-msclkid/catchMSCLKIDs.php?msclkid=' + lS_mscklid, {
      keepalive: true,
    });
  }
}